import emitter from 'tiny-emitter/instance';

export default {
    computed: {
        $events() {
            return emitter;
        }
    }
}